<template>
  <!-- The poster is the phone LCP element: AVIF is about half the bytes of the WebP at the same look. -->
  <picture>
    <source type="image/avif" :srcset="avifSrcset" sizes="100vw" />
    <img
      class="hero-backdrop"
      src="/home/video/hero-bg-poster.webp"
      srcset="/home/video/hero-bg-poster-640.webp 640w, /home/video/hero-bg-poster-960.webp 960w, /home/video/hero-bg-poster.webp 1920w"
      sizes="100vw"
      width="1920"
      height="1071"
      fetchpriority="high"
      alt=""
      aria-hidden="true"
    />
  </picture>
  <video
    v-if="videoEnabled"
    ref="video"
    class="hero-backdrop"
    src="/home/video/hero-bg-video-pingpong.mp4"
    muted
    loop
    playsinline
    preload="none"
    aria-hidden="true"
  ></video>
</template>

<script setup>
const video = ref(null);
const videoEnabled = ref(false);
let media;
let observer;
let timer;
let visible = false;
let disposed = false;

const avifSrcset = '/home/video/hero-bg-poster-640.avif 640w, /home/video/hero-bg-poster-960.avif 960w, /home/video/hero-bg-poster.avif 1920w';
// type makes browsers without AVIF skip the preload; they fetch the WebP from the img.
useHead({ link: [{
  rel: 'preload', as: 'image', type: 'image/avif', href: '/home/video/hero-bg-poster.avif',
  imagesrcset: avifSrcset, imagesizes: '100vw', fetchpriority: 'high',
}] });

const playback = () => {
  if (visible && !document.hidden && media?.matches) video.value?.play()?.catch(() => {});
  else video.value?.pause();
};
const sync = async () => {
  // Phones, reduced-motion and data-saving visitors keep the lightweight poster.
  videoEnabled.value = media.matches && !navigator.connection?.saveData;
  await nextTick();
  if (disposed) return;
  observer?.disconnect();
  if (video.value) observer.observe(video.value);
  playback();
};
const schedule = () => { timer = window.setTimeout(sync, 2500); };
onMounted(() => {
  media = window.matchMedia('(min-width: 768px) and (prefers-reduced-motion: no-preference)');
  observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; playback(); });
  media.addEventListener('change', sync);
  document.addEventListener('visibilitychange', playback);
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
});
onBeforeUnmount(() => {
  disposed = true;
  clearTimeout(timer);
  window.removeEventListener('load', schedule);
  media?.removeEventListener('change', sync);
  document.removeEventListener('visibilitychange', playback);
  observer?.disconnect();
});
</script>

<style scoped>
.hero-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -3;
  width: 100%;
  height: 100%;
  object-fit: fill;
  object-position: center bottom;
  filter: saturate(1.35) contrast(1.05);
}
@media (max-width: 640px) { .hero-backdrop { object-fit: cover; } }
</style>
